import LanguageDetector from 'i18next-browser-languagedetector';

export const convertDetectedLanguage = (fullLng: string) => {
  // supported languages in feron
  const supportedFeronLanguages = ['en', 'fr'];
  const searchParams = window.location.search;

  // any url loaded from shipping elements
  if (!searchParams.includes('Embed')) {
    if (supportedFeronLanguages.includes(fullLng.split('-')[0])) return fullLng.split('-')[0];
  } else {
    // return full language (ex. en-GB)
    return fullLng;
  }
};

export const languageDetector = new LanguageDetector();
